<template>
  <div id="app">
    <router-view>
    </router-view>
  </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
  #app {
      display: block;
      width: 100%;
      height: 100%;
    font-family: "PingFangSC-Regular";
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  .type_goods{
    margin-right: 5px;
    width: 16px;
    height: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue